import { Page } from "@/models/page-models/Page";

export const JournalMovements: Page = {
  "path": "journal-movements",
  "name": "List Of Journal Movements",
  "props": {
    "data": {
      "title": "List Of Journal Movements",
      "printable": "TRUE",
      "url": "journal-movements",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "radioGroup",
                  "variable": "formData.type",
                  "label": "Type",
                  "disabled": "FALSE",
                  "items": "[{\"label\":\"With Invoices\",\"value\":\"with-invoices\"},{\"label\":\"Without Invoices\",\"value\":\"without-invoices\"}]"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.startDate",
                  "label": "Start Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.endDate",
                  "label": "End Date",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load List of Journal Movements",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "getJournalMovements"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Journal Movements",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.journalMovements}}",
                  "items": "fetchedData.journalMovements.data",
                  "headers": [
                    {
                      "value": "refNo",
                      "text": "Ref No#"
                    },
                    {
                      "value": "customerId",
                      "text": "Customer"
                    },
                    {
                      "value": "voucherDate",
                      "text": "Voucher Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.voucherDate}})"
                    },
                    {
                      "value": "voucherType",
                      "text": "Voucher Type"
                    },
                    {
                      "value": "customerName",
                      "text": "Customer Name"
                    },
                    {
                      "value": "description",
                      "text": "Description"
                    },
                    {
                      "value": "debit",
                      "text": "Debit",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.debit}})"
                    },
                    {
                      "value": "credit",
                      "text": "Credit",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.credit}})"
                    }
                  ],
                  "tableType": "static"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "functions": [
      {
        "name": "getJournalMovements",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/reports/journal-movement?type={{formData.type}}&endDate={{formData.endDate}}&startDate={{formData.startDate}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.journalMovements"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": false
}